import { render } from "./sidebar-two.vue?vue&type=template&id=e0c2131c"
import script from "./sidebar-two.vue?vue&type=script&lang=js"
export * from "./sidebar-two.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__